require('normalize.css/normalize.css')
require('styles/App.less')

import React from 'react'
import MainVisual from './MainVisualComponent'
import MainScrollContent from './MainScrollContentComponent'
import Bg from './BgComponent'

var classNames = require('classnames')
var browser = require('./browser')

class AppComponent extends React.Component
{
  constructor(props)
  {
    super(props);
    browser.init()
  }
  render()
  {
    var ismobile = false
    if (browser.ua.isMobile || browser.ua.isIOS || browser.ua.isAndroid)
    {
      ismobile = true
    }
    var cl = classNames({
      mobile:ismobile
    })
    return (
      <div className={cl + ' index'}>
        <MainVisual />
        <Bg />
        <MainScrollContent />
      </div>
    )
  }
}

AppComponent.defaultProps = {
}

export default AppComponent



/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/